// src/utils/leavePrefill.js
// ✅ 캘린더 → 휴가신청서 바로가기 프리필(2026-10-19). 캘린더에서 고른 범위를 작성 화면 쿼리로 넘기고,
// 작성 화면이 그 쿼리를 다시 읽는다. 이동 + 채우기만 한다 — 일정은 승인 전에 절대 만들지 않는다.
//
// 규칙: 같은 날 시간대를 골랐으면 09:00~13:00 = 반차(오전), 14:00~18:00 = 반차(오후), 09:00~18:00 = 종일,
// 그 밖의 시각은 시간차. 날짜만 골랐으면(월 보기·종일 칸) 종일휴가 그 기간.
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const TIME_RE = /^\d{2}:\d{2}$/;
const KINDS = ["full", "half_am", "half_pm", "hourly"];

export function buildLeavePrefill({ startDate, endDate, startTime, endTime }) {
  const q = new URLSearchParams();
  const sameDay = !endDate || endDate === startDate;
  if (startTime && endTime && sameDay) {
    const range = `${startTime}-${endTime}`;
    const kind = { "09:00-13:00": "half_am", "14:00-18:00": "half_pm", "09:00-18:00": "full" }[range] || "hourly";
    q.set("kind", kind);
    q.set("start_date", startDate);
    if (kind === "hourly") {
      q.set("start_time", startTime);
      q.set("end_time", endTime);
    }
  } else {
    q.set("kind", "full");
    q.set("start_date", startDate);
    q.set("end_date", endDate || startDate);
  }
  return q.toString();
}

// 쿼리 → 작성 화면 값. 형식이 틀린 값은 버린다(null = 프리필 없음).
export function parseLeavePrefill(search) {
  const q = new URLSearchParams(search || "");
  const kind = q.get("kind");
  const startDate = q.get("start_date");
  if (!KINDS.includes(kind) || !DATE_RE.test(startDate || "")) return null;
  const endDate = kind === "full" && DATE_RE.test(q.get("end_date") || "") ? q.get("end_date") : startDate;
  const out = { kind, startDate, endDate: endDate < startDate ? startDate : endDate };
  if (kind === "hourly") {
    const st = q.get("start_time");
    const et = q.get("end_time");
    if (TIME_RE.test(st || "") && TIME_RE.test(et || "")) Object.assign(out, { startTime: st, endTime: et });
  }
  return out;
}

const pad = (n) => String(n).padStart(2, "0");
const localDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const localTime = (d) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;

// FullCalendar select(info) → 등록 창 범위. 종일 선택의 end는 다음 날 0시(배타)라 하루 뺀다.
export function rangeFromSelection({ start, end, allDay }) {
  if (allDay) {
    const last = new Date(end.getTime() - 24 * 3600 * 1000);
    return { startDate: localDate(start), endDate: localDate(last < start ? start : last), startTime: "", endTime: "" };
  }
  return { startDate: localDate(start), endDate: localDate(end), startTime: localTime(start), endTime: localTime(end) };
}
